module.exports = __webpack_public_path__ + "media/images/lb/275-adc8697290d24f63d5f2388d8255f105.svg";